import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

/*
 * togglePageScroll
 */

const togglePageScroll = (id: string, enable: boolean) => {
  const el = document.querySelector(id);

  if (el) {
    if (enable) {
      enableBodyScroll(el);
    } else {
      disableBodyScroll(el);
    }
  } else if (enable) {
    // ideally don't end up here if possible
    // the return function in a useEffect is fired after the component is removed. If this function is triggered from
    // there it won't be able to find the element specified. In this case we clear all scroll locks. But this may
    // inadvertently clear a lock you don't want to clear
    clearAllBodyScrollLocks();
  }
};

export default togglePageScroll;
